/**
 * lib/trainerGradingApi.js — LMS-Growth Sprint
 * ---------------------------------------------
 * Thin axios wrapper for the unified trainer grading queue + readiness
 * report PDF + auto-save status endpoints.  Provider names never reach
 * the frontend (we only ever hold opaque Diplomexa IDs here).
 */
import api, { formatApiError } from "./api";

export async function getGradingQueue({
  status = "pending", itemType = "all", limit = 50,
} = {}) {
  const p = new URLSearchParams();
  p.set("status", status);
  p.set("item_type", itemType);
  p.set("limit", String(limit));
  return (await api.get(`/lms/trainer/grading-queue?${p.toString()}`)).data;
}

export async function getGradingMetrics() {
  return (await api.get("/lms/trainer/grading-queue/metrics")).data;
}

export async function gradePaper(paperId, body) {
  return (
    await api.post(`/lms/trainer/grading-queue/papers/${paperId}/grade`, body)
  ).data;
}

export async function gradeResolution(resolutionId, body) {
  return (
    await api.post(
      `/lms/trainer/grading-queue/resolutions/${resolutionId}/grade`, body,
    )
  ).data;
}

// ── Readiness Report PDF + history ────────────────────────────────────────
export async function getMyReadinessReports(limit = 10) {
  return (await api.get(`/lms/readiness-reports/me?limit=${limit}`)).data;
}

export function readinessReportPdfUrl(reportId) {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return `${base}/api/lms/readiness-report/${reportId}/pdf`;
}

// ── Auto-save status pings ────────────────────────────────────────────────
export async function getPaperAutoSaveStatus(paperId) {
  return (await api.get(`/papers/draft/${paperId}/auto-save-status`)).data;
}

export async function getResolutionAutoSaveStatus(resolutionId) {
  return (
    await api.get(`/resolutions/draft/${resolutionId}/auto-save-status`)
  ).data;
}

export { formatApiError };
